import Svg, { Path } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const RefreshIcon = ({ width = 24, height = 24, color = '#fff' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M8.5 2.666c.898.003 1.78.232 2.567.667H10.5a.667.667 0 1 0 0 1.333h2A.667.667 0 0 0 13.167 4V2a.667.667 0 0 0-1.334 0v.24A6.666 6.666 0 0 0 8.5 1.333a6.667 6.667 0 0 0-5.767 3.333A6.627 6.627 0 0 0 1.833 8a.667.667 0 1 0 1.334 0A5.333 5.333 0 0 1 8.5 2.666Zm6.473 4.86a.666.666 0 0 0-1.14.474 5.333 5.333 0 0 1-7.893 4.666h.56a.667.667 0 1 0 0-1.333h-2a.666.666 0 0 0-.667.667v2a.667.667 0 1 0 1.334 0v-.24a6.667 6.667 0 0 0 3.333.906A6.665 6.665 0 0 0 15.167 8a.666.666 0 0 0-.194-.474Z"
    />
  </Svg>
)
export default RefreshIcon
